export default __webpack_public_path__ + "static/media/StudentIcon.2119fc12.svg";